import { render } from "./AppColorPicker.vue?vue&type=template&id=100dc304&scoped=true"
import script from "./AppColorPicker.vue?vue&type=script&lang=js"
export * from "./AppColorPicker.vue?vue&type=script&lang=js"

import "./AppColorPicker.vue?vue&type=style&index=0&id=100dc304&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-100dc304"]])

export default __exports__